import script from "./commonFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonFooter.vue?vue&type=script&setup=true&lang=ts"

import "./commonFooter.vue?vue&type=style&index=0&id=c2e54918&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2e54918"]])

export default __exports__